<div class="modal-header pd-x2" >
    <h5 class="modal-title">{{ "shipment.UpdateInformation" | cxTranslate }}</h5>
    <button type="button" class="close" aria-label="Close" (click)="close()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body " >   
    <form [formGroup]="materialform">
        <div class="mb-3 col-md-12 col-sm-12">
            <span class="semibold small">{{ "shipment.stockpilelocation" | cxTranslate }}</span>
            <input type="text" formControlName="stockPileLocation" class="form-control">           
        </div> 
        <div >
            <div *ngIf="section==='portside'" class="mb-3 d-flex justify-content-between align-items-center"><!--col-md-12 col-sm-12 mb-3 row ms-sm-auto-->
                <span class="semibold small col-md-8 col-sm-8 col-xs-8 " >{{ "shipment.Customsclearance" | cxTranslate }}</span>
                <div class="btn-group btn-group-toggle col-md-4 col-sm-4 col-xs-4" data-toggle="buttons">
                    <!-- <label id="yes" *ngFor="let btn of clearenceValues;let r=index;" class="btn m-0 border1 " [ngClass]="checkCustomClearenceFlag==true? 'active':''" (click)="checkCustomClearence(btn.id)">
                        <input type="radio"  formControlName="btn.id" name="btn.id" id="{{'option'+btn.id}}" 
                            class="h6 btn btn-block btn-light m-0 border1">{{btn.name}}</label> -->
                   <label id="yes" class="btn border1 min-height" [ngClass]="shipData.isCustomCleared==true? 'active_yes':''" (click)="checkCustomClearence('yes')">
                        <input type="radio" formControlName="clearence" name="options" id="{{'optionyes'}}" 
                            class="h6 btn btn-block btn-light m-0 border1">{{ "shipment.yes" | cxTranslate }}</label>
                    <label  id="no" class="btn border1 min-height" [ngClass]="shipData.isCustomCleared==false? 'active_no':''" (click)="checkCustomClearence('no')">
                        <input type="radio" formControlName="clearence" name="options" id="{{'optionno'}}" 
                            class="h6 btn btn-block btn-light m-0 border1">{{ "shipment.no" | cxTranslate }}</label>
                </div>                      
            </div>
            <!-- <input type="text"  formControlName="clearenceText" class="mb-3 col-md-12 col-sm-12 form-control"> -->
            <div class="mb-3 col-md-12 col-sm-12 col-xs-12" *ngIf="shipData.isCustomCleared==true && section==='portside'">
                    <div class="inline-filter date-range-picker-form to" >
                    <fieldset>
                        <input
                        class="form-control"
                        [readonly]="true"
                        name="s"
                        [footerTemplate]="footerTemplate" class="form-control  small ff-normal h-40 date-width"
                        ngbDatepicker  
                        #s="ngbDatepicker"
                        (click)="toggle(s)"
                        (dateSelect)="clearenceDateSelection($event)"                     
                        formControlName="clearenceDate" 
                        id="clearenceDate"
                        placeholder="DD/MM/YYYY"
                    />  <!-- [value]=formatter.format(SubstartDateClearence) -->
                     <ng-template #footerTemplate>
                            <hr class="my-0">
                            <button class="btn btn-outline-secondary  btn-sm m-2 float-end " (click)="s.close()">{{ 'home.quote.Close' | cxTranslate }}</button>
                        </ng-template>
                    </fieldset>
                </div>
            </div>
            <div class="mb-3 d-flex justify-content-between align-items-center"><!--col-md-12 col-sm-12 mb-3 row ms-sm-auto-->
                <span class="semibold small col-md-8 col-sm-8 col-xs-8 " >{{ "shipment.Dischargecompleted" | cxTranslate }}</span>
                <div class="btn-group btn-group-toggle col-md-4 col-sm-4 col-xs-4" data-toggle="buttons">
                   <label id="yes" class="btn border1 min-height" [ngClass]="shipData.isDischarged==true? ' disabled-highlight ':checkDischargeCompletedFlag == true? 'active_yes':''" (click)="checkDischargeCompleted('yes')">
                        <input type="radio" formControlName="discharge" name="options" id="{{'optionyes'}}" 
                            class="h6 btn btn-block btn-light m-0 border1">{{ "shipment.yes" | cxTranslate }}</label>
                    <label  id="no" class="btn border1 min-height" [ngClass]="shipData.isDischarged==false && checkDischargeCompletedFlag == false? 'active_no': shipData.isDischarged==false &&checkDischargeCompletedFlag == true ?'':'disabled'" (click)="checkDischargeCompleted('no')">
                        <input type="radio" formControlName="discharge" name="options" id="{{'optionno'}}" 
                            class="h6 btn btn-block btn-light m-0 border1">{{ "shipment.no" | cxTranslate }}</label>
                </div>                      
            </div>
        </div>
       <hr>
        <div class="mb-3 d-flex justify-content-between">
            <!-- <div class="row" > -->
                 <div class="col-md-6 col-sm-6 col-xs-6">
                    <div for="Select1" class="semibold small mb-1">{{ "shipment.ETA" | cxTranslate }}</div>
                        <div class="inline-filter date-range-picker-form to" >
                        <fieldset>
                            <input class="form-control" [readonly]="true" name="s" [footerTemplate]="footerTemplate"
                                class="form-control small ff-normal h-40 date-width" ngbDatepicker #a="ngbDatepicker"
                                (click)="toggle(a)"
                                (dateSelect)="etaDateSelection($event)" 
                                formControlName="etaDate" id="etaDate" 
                                placeholder="DD/MM/YYYY" [ngClass]="shipData.isDischarged==true? 'disabled':''" />
                            <ng-template #footerTemplate>
                                <hr class="my-0">
                                <button class="btn btn-outline-secondary  btn-sm m-2 float-end " (click)="s.close()">{{ 'home.quote.Close' |
                                    cxTranslate }}</button>
                            </ng-template>
                        </fieldset>
                    </div>
                </div>
                 <div class="col-md-6 col-sm-6 col-xs-6 mt-4">
                    <div class="select-editable">
                        <select  [ngClass]="shipData.isDischarged==true? 'disabled':''"  class="form-control" id="etaTime" placeholder="HH:MM" formControlName="etaTime" (change)="changeEtaTime($event)" onchange="this.nextElementSibling.value=this.value">
                            <option  [value]="etaTime" *ngFor="let etaTime of timeArray">{{etaTime}}</option>
                            </select>
                            <input [disabled]="shipData.isDischarged==true" timeFormat type="text" [value]="etaTimeInput"  placeholder="HH:MM" (change)="changeEtaTime($event)"><!-- onchange="this.previousElementSibling.selectedIndex=0"   oninput="this.previousElementSibling.options[0].value=this.value; this.previousElementSibling.options[0].innerHTML=this.value" -->
                    </div>  
                    
                </div> 
            <!-- </div> -->
           </div>
        <div class="mb-3 d-flex justify-content-between">     
               <div class="col-md-6 col-sm-6 col-xs-6">
                    <div for="Select1" class="semibold small mb-1">{{ "shipment.ETB" | cxTranslate }}</div>
                        <div class="inline-filter date-range-picker-form to" >
                        <fieldset>
                            <input
                            class="form-control"
                            [readonly]="true"
                            name="s"
                            class="form-control small ff-normal h-40 date-width"
                            ngbDatepicker                          
                            formControlName="etbDate" 
                            id="etbDate"
                            placeholder="DD/MM/YYYY" [ngClass]="shipData.isDischarged==true? 'disabled':''"
                            [footerTemplate]="footerTemplate" class="form-control small ff-normal h-40 date-width"
                            #b="ngbDatepicker"
                            (click)="toggle(b)"
                            (dateSelect)="etbDateSelection($event)"

                        /><!--                            [value]=formatter.format(SubstartDateEtb) 
                        -->
                         <ng-template #footerTemplate>
                                <hr class="my-0">
                                <button class="btn btn-outline-secondary  btn-sm m-2 float-end " (click)="s.close()">{{ 'home.quote.Close' | cxTranslate }}</button>
                            </ng-template>
                        </fieldset>
                    </div>
                </div>
                 <div class="col-md-6 col-sm-6 col-xs-6 mt-4">
                    <div class="select-editable">
                        <select [ngClass]="shipData.isDischarged==true? 'disabled':''" class="form-control" id="etbTime" placeholder="HH:MM" formControlName="etbTime" (change)="changeEtbTime($event)" onchange="this.nextElementSibling.value=this.value">
                            <option [value]="etbTime" *ngFor="let etbTime of timeArray">{{etbTime}}</option>
                            </select>
                        <input [disabled]="shipData.isDischarged==true" timeFormat type="text" [value]="etbTimeInput" placeholder="HH:MM" (change)="changeEtbTime($event)" onchange="this.previousElementSibling.selectedIndex=0"   oninput="this.previousElementSibling.options[0].value=this.value; this.previousElementSibling.options[0].innerHTML=this.value"><!--onchange="this.previousElementSibling.selectedIndex=0"   oninput="this.previousElementSibling.options[0].value=this.value; this.previousElementSibling.options[0].innerHTML=this.value" />-->
                    </div>  
                </div> 

        </div>
        <div class="mb-3 d-flex justify-content-between">
        
                <div class="col-md-6 col-sm-6 col-xs-6">
                    <div for="Select1" class="semibold small mb-1">{{ "shipment.ETSD" | cxTranslate }}</div>
                        <div class="inline-filter date-range-picker-form to" >
                        <fieldset>
                            <input
                            class="form-control"
                            [readonly]="true"
                            name="s"
                            class="form-control  small ff-normal h-40 date-width"
                            ngbDatepicker                          
                            formControlName="etsdDate" 
                            id="etsdDate"
                            placeholder="DD/MM/YYYY" [ngClass]="shipData.isDischarged==true? 'disabled':''"
                            [footerTemplate]="footerTemplate" class="form-control  small ff-normal h-40 date-width"
                            #c="ngbDatepicker"
                            (click)="toggle(c)"
                            (dateSelect)="etsdDateSelection($event)"
                        /><!--                            [value]=formatter.format(SubstartDateEtsd)
                        -->
                         <ng-template #footerTemplate>
                                <hr class="my-0">
                                <button class="btn btn-outline-secondary  btn-sm m-2 float-end " (click)="s.close()">{{ 'home.quote.Close' | cxTranslate }}</button>
                            </ng-template>
                        </fieldset>
                    </div>
                </div>
                 <div class="col-md-6 col-sm-6 col-xs-6 mt-4">
                    <div class="select-editable">
                        <select [ngClass]="shipData.isDischarged==true? 'disabled':''" class="form-control" id="etsdTime" placeholder="HH:MM" formControlName="etsdTime" (change)="changeEtsdTime($event)" onchange="this.nextElementSibling.value=this.value">
                            <option [value]="etsdTime" *ngFor="let etsdTime of timeArray">{{etsdTime}}</option>
                            </select>
                            <input [disabled]="shipData.isDischarged==true" timeFormat type="text" [value]="etsdTimeInput"  placeholder="HH:MM" (change)="changeEtsdTime($event)"onchange="this.previousElementSibling.selectedIndex=0"   oninput="this.previousElementSibling.options[0].value=this.value; this.previousElementSibling.options[0].innerHTML=this.value">
                    </div>  
                </div> 

        </div>
        <div class="mb-3 d-flex justify-content-between">
              <div class="col-md-6 col-sm-6 col-xs-6">
                    <div for="Select1" class="semibold small mb-1">{{ "shipment.ETCD" | cxTranslate }}</div>
                        <div class="inline-filter date-range-picker-form to" >
                        <fieldset>
                            <input
                            name="s"
                            class="form-control small ff-normal h-40 date-width"
                            ngbDatepicker                          
                            formControlName="etcdDate" 
                            id="etcdDate"
                            placeholder="DD/MM/YYYY" [ngClass]="shipData.isDischarged==true? 'disabled':''"
                            [footerTemplate]="footerTemplate" class="form-control  small ff-normal h-40 date-width"
                            #d="ngbDatepicker"
                            (click)="toggle(d)"
                            (dateSelect)="etcdDateSelection($event)"
                        /><!--                            [value]=formatter.format(SubstartDateEtcd)
                        -->
                         <ng-template #footerTemplate>
                                <hr class="my-0">
                                <button class="btn btn-outline-secondary  btn-sm m-2 float-end " (click)="s.close()">{{ 'home.quote.Close' | cxTranslate }}</button>
                            </ng-template>
                        </fieldset>
                    </div>
                </div>
                 <div class="col-md-6 col-sm-6 col-xs-6 mt-4">
                    <div class="select-editable">
                        <select [ngClass]="shipData.isDischarged==true? 'disabled':''" class="form-control" id="etcdTime" placeholder="HH:MM" formControlName="etcdTime" (change)="changeEtcdTime($event)" onchange="this.nextElementSibling.value=this.value">
                            <option [value]="etcdTime" *ngFor="let etcdTime of timeArray">{{etcdTime}}</option>
                            </select>
                            <input [disabled]="shipData.isDischarged==true" timeFormat type="text" [value]="etcdTimeInput"  placeholder="HH:MM" (change)="changeEtcdTime($event)"><!--onchange="this.previousElementSibling.selectedIndex=0"   oninput="this.previousElementSibling.options[0].value=this.value; this.previousElementSibling.options[0].innerHTML=this.value" />-->
                    </div>  
                </div> 

        </div>
    </form> 
    
</div>
<div class="modal-footer " >
    <div class="col-md-12 col-sm-12">
        <button class="btn btn-block btn-lg  btn-primary" type="submit" (click)="goToNext()">{{ "shipment.next" | cxTranslate }}</button> 
        <button class="btn btn-block btn-light btn-lg" type="submit" (click)="close()" data-dismiss="modal">{{ "shipment.cancel" | cxTranslate }}</button>
     </div>
</div>
